import i18next from 'i18next'
import { updateMyPreferences } from '@/routes/users'

export const changeLanguage = (lng: string, saveToBackend = true) => {
  i18next.changeLanguage(lng)
  if (saveToBackend) {
    updateMyPreferences({ language_preference: lng as 'es' | 'en' | 'pt' }).catch(() => {})
  }
}

export const getCurrentLanguage = () => i18next.language
